import { EditableTaxClass, TaxClassSummary } from "../types";

import { scaffoldEdit } from "common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "TAXES/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "TAXES/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "TAXES/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "TAXES/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "TAXES/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "TAXES/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableTaxClass, TaxClassSummary, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };

export type SavedAction = ReturnType<typeof createAction.saved>;
